import { RESERVED_ERROR_CODES } from "@cervval.js/common/src/errors/errors";
/**
 * Http Error codes related to authentication
 */
export enum AuthErrorCode {
    _RESERVED = RESERVED_ERROR_CODES, // Checked reserved error code here

    UNEXPECTED_LOGIN_ERROR = 530,
    WRONG_LOGIN_PASSWORD = 531,
    NO_LOGIN_DATA = 532
}